<!-- #63 -->
<template>
  <div>
    <v-form ref="form" lazy-validation>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="6"
            sm="6"
            v-if="userCategory.user_category === 3"
          >
            <v-autocomplete
              v-model="vendorDetails.clientid"
              :items="clients"
              :loading="clientLoader"
              item-text="name"
              item-value="id"
              label="Select client"
              :readonly="id > 0"
              @focus="fetchClientList"
              :rules="[(v) => !!v || 'Client is required.']"
              class="required"
              @change="getCountryList(vendorDetails.clientid)"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-text-field
              v-model="vendorDetails.vendor_name"
              label="Vendor Name"
              :rules="[(v) => (v && !!v.trim()) || 'Vendor name is required.']"
              class="required"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="4" sm="6">
            <v-text-field
              v-model="vendorDetails.vendor_code"
              label="Vendor Code"
              :rules="[(v) => (v && !!v.trim()) || 'Vendor code is required.']"
              class="required"
              :readonly="id > 0"
            ></v-text-field>
          </v-col> -->
        </v-row>
        <v-divider class="pl-0 pr-0"></v-divider>

        <v-row class="mt-2">
          <v-col cols="12" md="4" sm="6">
            <v-text-field
              v-model="vendorDetails.billing_address"
              label="Billing Address"
              :rules="[
                (v) => (v && !!v.trim()) || 'Billing Address is required.',
              ]"
              class="required"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              label="Country"
              :items="allCountries"
              v-model="vendorDetails.billing_address_country_id"
              item-text="country"
              item-value="client_country_id"
              :rules="[(v) => !!v || 'Country is required']"
              class="required"
              @input="cityList(vendorDetails.billing_address_country_id)"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              label="City"
              :items="citiesList"
              item-text="city"
              item-value="client_city_id"
              v-model="vendorDetails.billing_address_city_id"
              :rules="[(v) => !!v || 'City is required']"
              class="required"
              :loading="cityLoader"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="vendorDetails.billing_address_zip_code"
              label="Pincode / Zipcode"
              class="required"
              :rules="[(v) => (v && !!v.trim()) || 'Pincode is required.']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="vendorDetails.billing_phone_number"
              label="Phone Number"
              class="required"
              :rules="[(v) => (v && !!v.trim()) || 'Phone Number is required.']"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-2">
          <v-col cols="12" md="4" sm="6">
            <v-text-field
              v-model="vendorDetails.shipping_address"
              label="Shipping Address"
              :rules="[
                (v) => (v && !!v.trim()) || 'Shipping Address is required.',
              ]"
              class="required"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              label="Shipping Country"
              :items="allCountries"
              v-model="vendorDetails.shipping_address_country_id"
              item-text="country"
              item-value="client_country_id"
              :rules="[(v) => !!v || 'Shipping Country is required']"
              class="required"
              @input="
                cityListshipping(vendorDetails.shipping_address_country_id)
              "
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              label="Shipping City"
              :items="citiesListShipping"
              item-text="city"
              item-value="client_city_id"
              :loading="citySHippingLoader"
              v-model="vendorDetails.shipping_address_city_id"
              :rules="[(v) => !!v || 'Shipping City is required']"
              class="required"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="vendorDetails.shipping_address_zip_code"
              label="Pincode / Zipcode"
              :rules="[(v) => (v && !!v.trim()) || 'Pincode is required.']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="vendorDetails.shipping_phone_number"
              label="Phone Number"
              :rules="[(v) => (v && !!v.trim()) || 'Phone Number is required.']"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-card-action>
            <v-btn
              v-if="id == 0"
              color="primary"
              @click="save"
              :loading="saveLoader"
              class="ma-2"
              >Save</v-btn
            >
            <v-btn
              v-if="id > 0"
              color="primary"
              @click="save"
              :loading="saveLoader"
              class="ma-2"
              >Update</v-btn
            >
            <v-btn class="ml-3" color="error" @click="cancelOrder">
              Cancel
            </v-btn>
          </v-card-action>
        </v-row>
      </v-card-text>
    </v-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { reportTypes, reportTools } from "@/config/data";

export default {
  props: {
    id: {
      type: Number,
    },
  },
  watch: {
    id(newValue) {
      this.id = newValue;
      if (this.id > 0) {
        this.fetchDetails();
      }
    },
  },
  computed: {
    ...mapGetters(["clientTypes", "userTypes", "userCategory"]),
    reportTypes() {
      return reportTypes;
    },
    reportTools() {
      return reportTools;
    },
  },

  data() {
    return {
      pageLoader: false,
      vendorDetails: {},
      clientLoader: false,
      userLoader: false,
      clients: [],
      userGroup: [],
      value: [],
      user_gropu_id_value: [],
      citiesList: [],
      allCountries: [],
      cityLoader: false,
      citySHippingLoader: false,
      dataArray: [],
      saveLoader: false,
      citiesListShipping: "",
    };
  },
  created() {
    if (+this.id !== 0) {
      this.fetchDetails();
    }
    if (this.userCategory.user_category == 3) this.fetchClientList();
    if (this.userCategory.user_category == 1)
      this.getCountryList(this.$store.getters.user.id);
  },
  methods: {
    ...mapActions([
      "snackBar",
      "fetchClient",
      "fetchCityList",
      "getCountries",
      "createVendor",
      "getFulfillmentCountryList",
      "getvendorDetails",
      "updateVendor",
    ]),
    cancelOrder() {
      this.$emit("closePopup");
      this.$refs.form.reset();
    },
    async getCountryList(id) {
      await this.getFulfillmentCountryList(id)
        .then((res) => {
          this.dataArray = res.data.response;
          const countryIdMap = new Map();

          this.dataArray.forEach((item) => {
            if (!countryIdMap.has(item.client_country_id)) {
              countryIdMap.set(item.client_country_id, item.country);
            }
          });

          this.allCountries = Array.from(
            countryIdMap,
            ([client_country_id, country]) => ({ client_country_id, country })
          );
        })
        .catch(() => {
          this.allCountries = [];
        });
    },
    cityList(targetClientId) {
      this.cityLoader = true;
      this.citiesList = this.dataArray
        .filter((item) => item.client_country_id === targetClientId)
        .map((item) => ({
          city: item.city,
          client_city_id: item.client_city_id,
        }));
      this.cityLoader = false;
    },
    cityListshipping(targetClientId) {
      this.citySHippingLoader = true;
      this.citiesListShipping = this.dataArray
        .filter((item) => item.client_country_id === targetClientId)
        .map((item) => ({
          city: item.city,
          client_city_id: item.client_city_id,
        }));
      this.citySHippingLoader = false;
    },

    async fetchClientList() {
      if (this.clients.length > 0) return;
      this.clientLoader = true;
      await this.fetchClient({
        fields: "id,name",
        pagination: 0,
        service: "fulfillment,fulfillment_wid_last_mile",
      })
        .then((res) => {
          this.clientLoader = false;
          this.clients = res.data;
        })
        .catch(() => {
          this.clientLoader = false;
        });
    },

    async fetchDetails() {
      this.pageLoader = true;
      await this.getvendorDetails(this.id)
        .then(async (res) => {
          this.pageLoader = false;
          this.vendorDetails = res.data.records[0];
          this.vendorDetails.clientid = res.data.records[0].client_id;
          this.vendorDetails.billing_address =
            res.data.records[0].billing_address_line1;
          this.vendorDetails.shipping_address =
            res.data.records[0].shipping_address_line1;
          this.vendorDetails.shipping_phone_number =
            res.data.records[0].shipping_address_phone;
          this.vendorDetails.billing_phone_number =
            res.data.records[0].billing_address_phone;

          await this.getCountryList(res.data.records[0].client_id);
          await this.cityList(this.vendorDetails.billing_address_country_id);
          await this.cityListshipping(
            this.vendorDetails.shipping_address_country_id
          );
        })
        .catch(() => {
          this.pageLoader = false;
        });
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;
      if (+this.id !== 0) {
        delete this.vendorDetails.oms_id;
        this.updateVendor({
          id: this.id,
          data: this.vendorDetails,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            let id = this.vendorDetails.clientid;

            this.$emit("savepopup", id);
            // this.$router.replace({
            //   name: "Vendor",
            // });
          })
          .catch((err) => {
            this.saveLoader = false;
            this.snackBar({
              color: "error",
              message: err[0].message,
            });
          });
      } else {
        this.saveLoader = true;
        this.createVendor(this.vendorDetails)
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            let id = this.vendorDetails.clientid;

            this.$emit("savepopup", id);
          })
          .catch((err) => {
            this.saveLoader = false;
            this.snackBar({
              color: "error",
              message: err[0].message,
            });
          });
      }
    },
  },
};
</script>
